import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import EducationForm from '../../../Education/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { DialogContentText } from '@material-ui/core'

export default function EducationDialog(props) {
  const { open, handleClose, initialValues, setPropChange } = props
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()
    setPropChange(true)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Education</DialogTitle>
      <DialogContentText>
        Relevant education helps us match you more effectively with potential clients.
      </DialogContentText>
      <StyledContent>
        <EducationForm initialValues={initialValues} profileReviewDialog={true} />
      </StyledContent>
      <Divider />
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="primary">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
